var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "75px",
    viewBox: "0 0 75 75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2716C3D9-35BB-4A34-80DC-85516A970D3A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.5,0.703125028 C57.7083333,0.703125028 74.1666667,17.1614584 74.1666667,37.3697917 C74.1666667,57.578125 57.7083333,74.0364584 37.5,74.0364584 C17.2916667,74.0364584 0.833333333,57.578125 0.833333333,37.3697917 C0.833333333,17.1614584 17.2916667,0.703125028 37.5,0.703125028 Z M37.5,3.82812503 C18.9583333,3.82812503 3.95833333,18.828125 3.95833333,37.3697917 C3.95833333,55.9114584 18.9583333,70.9114584 37.5,70.9114584 C56.0416667,70.9114584 71.0416667,55.9114584 71.0416667,37.3697917 C71.0416667,18.828125 56.0416667,3.82812503 37.5,3.82812503 Z M37.5,30.4947917 C38.75,30.4947917 39.5833333,31.328125 39.5833333,32.578125 L39.5833333,56.5364584 C39.5833333,57.578125 38.75,58.6197917 37.5,58.6197917 C36.25,58.6197917 35.4166667,57.7864584 35.4166667,56.5364584 L35.4166667,32.578125 C35.4166667,31.328125 36.25,30.4947917 37.5,30.4947917 Z M37.5,18.4114584 C38.75,18.4114584 39.5833333,19.2447917 39.5833333,20.4947917 L39.5833333,22.578125 C39.5833333,23.828125 38.75,24.6614584 37.5,24.6614584 C36.25,24.6614584 35.4166667,23.828125 35.4166667,22.578125 L35.4166667,20.4947917 C35.4166667,19.2447917 36.25,18.4114584 37.5,18.4114584 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Systems-Manager-Enrollment-screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone-/-What-can-my-admin",
    transform: "translate(-139.000000, -94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info",
    transform: "translate(139.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "color/1$gray-20",
    mask: "url(#mask-2)",
    fill: "#69696B"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: 0,
    y: 0,
    width: 75,
    height: 75
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e7e5d57e018b0f760214265517167793.svg";
export { ForwardRef as ReactComponent };